import { useCommunityId } from '@/hooks/communities';
import { useUnits } from '@/hooks/units';
import HomePage from '@/pages/HomePage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_layout/')({
  component: HomePage,
  loader: async ({ context: { queryClient } }) => {
    const data = await useCommunityId.ensureQueryData(queryClient);
    if (data?.communityId) {
      await useUnits.ensureQueryData(queryClient, [data.communityId]);
    }
  },
});
